import React from "react";
import { Link } from "react-router-dom";

const AdminPanel = () => {
  return (
    <div className="admin-container">
      <div className="max-w-4xl w-full shadow-lg rounded-lg p-6 space-y-6">
        <h2 className="text-3xl font-semibold text-gray-800 text-center">
          Admin Dashboard
        </h2>

        <div className="flex justify-center space-x-6 mt-8">
          <Link
            to="/admin/schedule"
            className="px-6 py-2 bg-blue-600 text-white rounded-xl shadow hover:bg-blue-700 transition"
          >
            Schedule Session
          </Link>
          <Link
            to="/admin/register-user"
            className="px-6 py-2 bg-green-600 text-white rounded-xl shadow hover:bg-green-700 transition"
          >
            Register User
          </Link>
          <Link
            to="/admin/resendpassword"
            className="px-6 py-2 bg-purple-600 text-white rounded-xl shadow hover:bg-purple-700 transition"
          >
            Resend Temp Password
          </Link>
          <Link
            to="/admin/presignlinkgenerator"
            className="px-6 py-2 bg-orange-600 text-white rounded-xl shadow hover:bg-orange-700 transition"
          >
            Presign Link Generator
          </Link>
        </div>
      </div>
    </div>
  );
};

export default AdminPanel;